exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top_nav[data-v-4896920a]{width:100%;height:40px;padding:0 20px;background-color:#ffffff}.top_nav .svg-icon[data-v-4896920a]{fill:#cccccc;margin-right:10px !important}\n", ""]);

// exports
